module.exports = __webpack_public_path__ + "img/classifica.59ff783e.png";